export default "__VITE_ASSET__NEb7QXVH__"